// material
// components
import { useContext } from "react";
import { ProjectContext } from "../../../utils/contexts/project";
import ProjectPeopleList from './list';
// ----------------------------------------------------------------------
export default function UserManagement() {
  let projectContext = useContext(ProjectContext);
  const { project } = projectContext;
  if (!project) { return <div>Select a Project to View</div> }
  if (project) {
    return <ProjectPeopleList project={project} />
  }
}
